import {Types} from 'mongoose';

export const COMMUNITY_REPRESENTATION = {
    type: 'Community Representation',
    category: 'General',
    value: [
        {_id: new Types.ObjectId('507f1f77bcf86cd799439086'), label: 'Arts'},
        {_id: new Types.ObjectId('507f1f77bcf86cd799439087'), label: 'Business'},
        {_id: new Types.ObjectId('507f1f77bcf86cd799439088'), label: 'Education'},
        {_id: new Types.ObjectId('507f1f77bcf86cd799439089'), label: 'Finance'},
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439090'),
            label: 'Government',
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439091'),
            label: 'Healthcare',
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439092'),
            label: 'Neighborhood coalition',
        },
        {_id: new Types.ObjectId('507f1f77bcf86cd799439093'), label: 'Other'},
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439094'),
            label: 'Philanthropy',
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439095'),
            label: 'Social Services',
        },
        {_id: new Types.ObjectId('507f1f77bcf86cd799439096'), label: 'Sports'},
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439097'),
            label: 'Technology',
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439098'),
            label: 'Trade Union/Professional organization',
        },
    ].map(d => ({...d, active: true})),
};
